import { logUsage } from 'owa-analytics';
import { updateUserOptions, updateUserConfiguration } from 'owa-options-core';
import datapoints from '../datapoints';
import getSelectedAccessibilityOption from '../selectors/getSelectedAccessibilityOption';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

/**
 * Function which updates the selected option value
 * in store and makes a service call
 */
export default async function saveAccessibilityOption() {
    const { name: eventName, customData } = datapoints.AccessibleContentSetting.datapoint;
    const userOptions = getUserConfiguration().UserOptions;
    const selectedOption = getSelectedAccessibilityOption();

    if (!userOptions) {
        return;
    }

    updateUserOptions({ PreferAccessibleContent: selectedOption });

    await updateUserConfiguration([
        {
            propertyName: 'PreferAccessibleContent',
            propertyType: 'Boolean',
            propertyValue: `${userOptions.PreferAccessibleContent}`,
        },
    ]);

    logUsage(eventName, customData(selectedOption));
}
